// Adds a persisted per-block text-direction attribute to a CKEditor 5 instance.
// Elements without an explicit dir end up auto-detected via CSS (unicode-bidi:
// plaintext, see .ck-content rules in App.css); once the user toggles a block's
// direction here, dir="rtl"/"ltr" is written into the model and survives getData().
export const BLOCK_TYPES_WITH_DIRECTION = [
  "paragraph",
  "heading1",
  "heading2",
  "heading3",
  "heading4",
  "listItem",
  "blockQuote",
];

export function setupDirectionSupport(editor) {
  BLOCK_TYPES_WITH_DIRECTION.forEach((type) => {
    if (editor.model.schema.isRegistered(type)) {
      editor.model.schema.extend(type, { allowAttributes: "direction" });
    }
  });

  editor.conversion.for("upcast").attributeToAttribute({
    view: { key: "dir" },
    model: "direction",
  });
  editor.conversion.for("downcast").attributeToAttribute({
    model: "direction",
    view: "dir",
  });
}

export function setBlockDirection(editor, dir) {
  if (!editor) return;
  editor.model.change((writer) => {
    const blocks = Array.from(editor.model.document.selection.getSelectedBlocks());
    blocks.forEach((block) => {
      if (dir) {
        writer.setAttribute("direction", dir, block);
      } else {
        writer.removeAttribute("direction", block);
      }
    });
  });
  editor.editing.view.focus();
}

// Returns "rtl" | "ltr" | null for the block(s) at the current selection.
export function getBlockDirection(editor) {
  if (!editor) return null;
  const blocks = Array.from(editor.model.document.selection.getSelectedBlocks());
  if (!blocks.length) return null;
  return blocks[0].getAttribute("direction") || null;
}
